/**
 * Thrown when an API call receives a 401 Unauthorized response,
 * indicating the user's session has expired or is missing.
 */
export class AuthenticationError extends Error {
  constructor(message = 'Authentication required — please sign in again') {
    super(message);
    this.name = 'AuthenticationError';
  }
}
